module.exports = __webpack_public_path__ + "static/media/collapse.9a2cd983.svg";